import { authHeader } from "../../_helpers";
import axios from "axios";

export const assessmentSummaryService = {
  getBatchHandler,
  getAssessementHandler,
  getAssessmentReportHandler,
};
axios.defaults.headers.common = authHeader();

function getBatchHandler(selId, orgId) {
  return axios
    .get(
      `/assessments/organisation/batch/add/list/` + selId + `/` + orgId + `/`
    )
    .then((response) => {

      localStorage.setItem("Super_admin_sellerID", selId);
      return response;
    });
}

function getAssessementHandler(data) {
  return axios
    .post(`/assessments/organisation/batch/summary/`, data)
    .then((response) => {

      return response;
    });
}

function getAssessmentReportHandler(data) {

  return axios
    .get(
      `/assessments/organisation/assessment/details/${data.sellerId}/${data.organisation_id
      }/${data.id}/${data.batch_id === "unalloted" ? 0 : data.batch_id}/`
    )
    .then((response) => {
      return response;
    });
}



// WEBPACK FOOTER //
// ./src/_services/assessmentSummary/assessmentSummary.service.js